<div
    class="footer-area text-center bg-white border-top-radius box-shadow"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
    [class.card-border-radius]="themeService.isCardBorderRadius()"
>
    <p>© Um produto implementado para <a class="fw-semibold" target="_blank">{{environment.companyName}}</a></p>
</div>